import React from "react";
import { Button } from "../ui/button";
import { Users, Play, Pause, Square, SkipBack, SkipForward, Volume2, VolumeX, Minimize2 } from "lucide-react";
import { photoUrl } from "../../lib/api";
import { kinshipLabel } from "../../lib/layout";
import { stopPointer } from "./treeConstants";

function captionLine(isMe, rel, member) {
  if (isMe) return "This is you";
  if (rel) return `Your ${rel}`;
  return member.birth_date ? `b. ${member.birth_date}` : "A relative";
}

export function TourCaption({ tour, focusId, byId, members, homeId, total }) {
  const m = byId[focusId]; if (!m) return null;
  const isMe = focusId === homeId;
  const rel = !isMe && homeId && byId[homeId] ? kinshipLabel(members, homeId, focusId) : null;
  const ph = photoUrl(m.photo_path);
  return (
    <div data-testid="tour-caption" className="pointer-events-none absolute bottom-24 left-1/2 z-40 flex -translate-x-1/2 items-center gap-3 rounded-2xl border border-[#D4A017]/40 bg-white/95 px-4 py-3 shadow-xl backdrop-blur">
      <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full bg-[#E8EEF3] ring-2 ring-[#D4A017]">{ph ? <img src={ph} alt="" className="h-full w-full object-cover" /> : <div className="flex h-full w-full items-center justify-center text-[#94A3B8]"><Users size={20} /></div>}</div>
      <div className="min-w-[150px]">
        <div className="font-serif text-base font-semibold leading-tight text-[#082D4A]" data-testid="tour-caption-name">{m.full_name}</div>
        <div className="text-xs text-[#64748B]">{captionLine(isMe, rel, m)}</div>
      </div>
      <div className="ml-1 shrink-0 rounded-full bg-[#082D4A] px-2 py-0.5 text-[10px] font-bold text-white" data-testid="tour-progress">{tour.i + 1} / {total}</div>
    </div>
  );
}

export function PresenterBar({ tour, total, paused, voice, presenting, canStart, onPrev, onNext, onTogglePause, onStop, onStart, onToggleVoice, onExit }) {
  return (
    <div data-testid="presenter-bar" onPointerDown={stopPointer} className="absolute bottom-6 left-1/2 z-40 flex -translate-x-1/2 items-center gap-1 rounded-full border border-[#D8E0E8] bg-white/95 px-2 py-1.5 shadow-xl backdrop-blur">
      {tour ? (
        <>
          <Button size="icon" variant="ghost" onClick={onPrev} disabled={tour.i <= 0} data-testid="tour-prev-button" title="Previous" className="rounded-full"><SkipBack size={16} /></Button>
          <Button size="icon" variant="ghost" onClick={onTogglePause} data-testid="tour-playpause-button" title={paused ? "Play" : "Pause"} className="rounded-full">{paused ? <Play size={16} /> : <Pause size={16} />}</Button>
          <Button size="icon" variant="ghost" onClick={onNext} disabled={tour.i >= total - 1} data-testid="tour-next-button" title="Next" className="rounded-full"><SkipForward size={16} /></Button>
          <Button size="icon" variant="ghost" onClick={onStop} data-testid="tour-stop-button" title="Stop tour" className="rounded-full text-[#B0850F]"><Square size={15} /></Button>
        </>
      ) : (
        canStart && <Button onClick={onStart} data-testid="tour-start-button" variant="ghost" className="gap-1.5 rounded-full px-3"><Play size={15} /> Start tour</Button>
      )}
      <Button size="icon" variant="ghost" onClick={onToggleVoice} data-testid="tour-voice-button" title={voice ? "Mute narration" : "Narrate aloud"} className={`rounded-full ${voice ? "text-[#082D4A]" : "text-[#94A3B8]"}`}>{voice ? <Volume2 size={16} /> : <VolumeX size={16} />}</Button>
      {presenting && (<><span className="mx-1 h-5 w-px bg-[#D8E0E8]" /><Button size="icon" variant="ghost" onClick={onExit} data-testid="exit-presenter-button" title="Exit presenter" className="rounded-full"><Minimize2 size={16} /></Button></>)}
    </div>
  );
}
